import { toast } from "@/components/custom-toast/Toast";

export async function apiCall(fn, fnName) {
  try {
    const res = await fn();
    if (res?.error) {
      toast.error(res.error || 'Something went wrong');
      return null;
    }
    return res;
  } catch (err) {
    const message = err?.response?.data?.message || err?.message || 'Something went wrong';
    console.error(`[API Error] ${fnName}:`, message);
    toast.error(message);
    return null;
  }
}
